import '../CsvJsonInfoPages.scss';


function BodyStyles() {

    const data = [
        { field: 1, description: 'Body Style Code (Char)' },
        { field: 2, description: 'Body Style Description (Char)' },
    ];


    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Body Styles</h1>
            <p>This file contains a list of bodystyles coded by CAP. The bodystyles are linked in the CAPcode. <br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_CAPBodyStyle.txt .txt<br />
                LIGHTS_yyyy-mm-dd_CAPBodyStyle.txt .txt<br />
                HEAVIES_yyyy-mm-dd_CAPBodyStyle.txt .txt<br />
                BIKES_yyyy-mm-dd_CAPBodyStyle.txt .txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.

            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
}

export default BodyStyles;
